import { TAGThemeProvider } from '@aspendental/shared-components-web';
import { AppContextProvider } from '@aspendental/shared-components-web/lib/context/AppContextProvider.ctx';
import { FacilityContextProvider } from '@aspendental/shared-components-web/lib/context/FacilityContextProvider.ctx';
import { TAGBrand } from '@aspendental/shared-components-web/lib/types';
import { ContentfulLivePreviewProvider } from '@contentful/live-preview/react';
import { StyledEngineProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { Provider } from 'urql';
import { getBeffeGraphQlClient } from '@src/lib/client';
export const ContextProviders = ({
  config,
  preview,
  environment,
  children,
  user,
  defaultToCdn = false
}) => {
  const router = useRouter();
  const brandTheme = config?.themeId || process.env.TAG_BRAND_THEME || 'aspendental';
  const brandName = brandTheme as TAGBrand;
  const [isClient, setIsClient] = useState(false);
  const beffeGraphQlUrl = environment === 'prod' ? config.services.prod.BEFFE_GRAPHQL_URL : config.services.nonprod.BEFFE_GRAPHQL_URL;
  const client = getBeffeGraphQlClient(beffeGraphQlUrl);
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false
      }
    }
  });
  useEffect(() => {
    setIsClient(true);
  }, []);
  return <Provider value={client} data-sentry-element="Provider" data-sentry-component="ContextProviders" data-sentry-source-file="ContextProviders.tsx">
			<QueryClientProvider client={queryClient} data-sentry-element="QueryClientProvider" data-sentry-source-file="ContextProviders.tsx">
				<ContentfulLivePreviewProvider locale={router.locale || 'en-US'} enableInspectorMode={preview} enableLiveUpdates={preview} data-sentry-element="ContentfulLivePreviewProvider" data-sentry-source-file="ContextProviders.tsx">
					<AppContextProvider config={config} theme={brandName} environment={environment} appName={process.env.APP_NAME || 'tag_dev'} appVersion={`${process.env.APP_VERSION || 'unknown'}(design-system:${process.env.DESIGN_SYSTEM_VERSION})`} data-sentry-element="AppContextProvider" data-sentry-source-file="ContextProviders.tsx">
						<StyledEngineProvider injectFirst data-sentry-element="StyledEngineProvider" data-sentry-source-file="ContextProviders.tsx">
							<TAGThemeProvider branding={brandName as TAGBrand} data-sentry-element="TAGThemeProvider" data-sentry-source-file="ContextProviders.tsx">
								{isClient && <FacilityContextProvider appName="tag_dev" appVersion="0.0.0" brand={brandName as TAGBrand} user={user} defaultToCdn={defaultToCdn}>
										{children}
									</FacilityContextProvider>}
							</TAGThemeProvider>
						</StyledEngineProvider>
					</AppContextProvider>
				</ContentfulLivePreviewProvider>
			</QueryClientProvider>
		</Provider>;
};